import { Component } from 'react';
import { Button } from 'react-bootstrap';
import cx from 'classnames';
import MultiChoiceResponse from './MultiChoiceResponse';
import style from './SingleAnswerMultiChoiceQuestion.scss';
import { createInstructionMarkup, questionComponentPropTypes } from './helpers';
import Immutable from 'immutable';

class SingleAnswerMultiChoiceQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showResult: !!props.response.get('answer'),
    };
  }

  handleResponseChange = (e) => {
    this.setState({
      showResult: false,
    });
    this.props.onResponseChange(
      this.props.response.set('answer', parseInt(e.target.value, 10))
    );
  };

  handleSaveClick = () => {
    this.setState({
      showResult: true,
    });
    this.props.onSaveClick();
  };

  render() {
    return (
      <div
        className={cx('question multi-choice single-answer', {
          [style.slideshow]: this.props.isSlideshow,
        })}
      >
        <span
          dangerouslySetInnerHTML={createInstructionMarkup(this.props.question)}
        />
        <MultiChoiceResponse
          showResult={this.state.showResult}
          answers={this.props.question.get('answers')}
          checked={[this.props.response.get('answer')]}
          stats={this.props.quizStats}
          onChange={this.handleResponseChange}
          isSlideshow={this.props.isSlideshow}
        />
        <Button
          onClick={this.handleSaveClick}
          disabled={!this.props.response.get('answer') || this.props.isSaving}
          className={cx({
            [style.button]: this.props.isSlideshow,
          })}
        >
          Save &amp; continue &raquo;
        </Button>
      </div>
    );
  }
}

SingleAnswerMultiChoiceQuestion.propTypes = questionComponentPropTypes;
SingleAnswerMultiChoiceQuestion.defaultProps = {
  response: Immutable.Map(),
};

export default SingleAnswerMultiChoiceQuestion;
